import styled from "styled-components";

export const BillDetailsBannerContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.large} calc(${theme.spacing.medium} * -1) calc(${theme.spacing.small} * -1) calc(${theme.spacing.medium} * -1)`,
}));
